import { useRef, useState } from "react";
import { Mic, Loader2, Square } from "lucide-react";
import { toast } from "sonner";
import { API } from "../lib/api";
export const MicButton = ({ onTranscript, inline }) => {
  const [state, setState] = useState("idle"); // idle | recording | working
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);
  const streamRef = useRef(null);

  const start = async () => {
    try {
      const unlock = new SpeechSynthesisUtterance('');
      window.speechSynthesis.speak(unlock);
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;
      const mime = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "";
      const mr = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
      chunksRef.current = [];
      mr.ondataavailable = (e) => e.data.size > 0 && chunksRef.current.push(e.data);
      mr.onstop = async () => {
        streamRef.current?.getTracks().forEach((t) => t.stop());
        streamRef.current = null;
        const blob = new Blob(chunksRef.current, { type: mr.mimeType || "audio/webm" });
        setState("working");
        try {
          const fd = new FormData();
          const ext = (mr.mimeType || "audio/webm").includes("mp4") ? "mp4" : "webm";
          fd.append("file", blob, `voz.${ext}`);
          const res = await fetch(`${API}/stt`, { method: "POST", body: fd });
          const data = await res.json();
          const text = (data.text || "").trim();
          if (text) onTranscript(text);
          else toast("No te he entendido, prueba de nuevo.");
        } catch (e) {
          toast.error("No se pudo transcribir la voz.");
        }
        setState("idle");
      };
      mr.start();
      mediaRef.current = mr;
      setState("recording");
    } catch (e) {
      toast.error("Necesito permiso para usar el micrófono.");
      setState("idle");
    }
  };

  const stop = () => {
    if (mediaRef.current && mediaRef.current.state !== "inactive") mediaRef.current.stop();
  };

  const toggle = () => {
    if (state === "idle") start();
    else if (state === "recording") stop();
  };

  return (
    <button
      data-testid="mic-talk-btn"
      onClick={toggle}
      disabled={state === "working"}
            className={inline
        ? "w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
        : "fixed left-5 bottom-28 z-50 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300"}
      style={{
        background: state === "recording" ? "#c0392b" : "linear-gradient(180deg,#e8c85a,#d4af37)",
        boxShadow: state === "recording" ? "0 0 26px rgba(192,57,43,0.6)" : "0 0 22px rgba(245,158,11,0.4)",
      }}
      aria-label="Hablar con Catalina"
    >
      {state === "recording" && <span className="absolute inset-0 rounded-full voice-ring" style={{ background: "rgba(192,57,43,0.5)" }} />}
      {state === "working" ? (
        <Loader2 size={22} className="animate-spin" style={{ color: "#1a1408" }} />
      ) : state === "recording" ? (
        <Square size={20} style={{ color: "#fff" }} fill="#fff" />
      ) : (
        <Mic size={22} style={{ color: "#1a1408" }} />
      )}
    </button>
  );
};
